import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from '../views/Home/Home'
import Live from '../views/live'

import LiveCast from '../views/liveCast'
import Login from '../views/auth/Login/Index'
import JifuAcademy from '../jifuAcademy'
import Dashboard from '../jifuAcademy/views/Dashboard'
import Travel from '../jifuAcademy/views/Travel'
import Health from '../jifuAcademy/views/Health'
import University from '../jifuAcademy/views/University'
import LiveNow from '../jifuAcademy/views/Live'
import Team from '../jifuAcademy/views/Team'
import Profile from '../jifuAcademy/views/Profile'
import ChartI from '../jifuAcademy/views/Affiliate'
import Announcements from '../jifuAcademy/views/Announcements'
import Chat from '../jifuAcademy/views/Chat/Index';


function Routing() {
    return (
        <div>

            <Routes>
                <Route exact path='/' element={<Home/>} />
                <Route exact path='/live' element={<Live/>} />
                <Route exact path='/live-cast' element={<LiveCast/>} />
                <Route exact path='/login' element={<Login/>} />
                <Route exact path='jifu-academy' element={<JifuAcademy/>}>
                    <Route exact path='dashboard' element={<Dashboard/>} />
                    <Route exact path='travel' element={<Travel/>} />
                    <Route exact path='health' element={<Health/>} />
                    <Route exact path='university' element={<University/>} />
                    <Route exact path='live' element={<LiveNow/>} />
                    <Route exact path='chart-ideas' element={<ChartI/>} />
                    <Route exact path='team' element={<Team/>} />
                    <Route exact path='profile' element={<Profile/>} />
                    <Route exact path='announcements' element={<Announcements/>} />
                    <Route exact path='chat' element={<Chat/>} />
                </Route>
                
            </Routes>
        </div>
    )
}

export default Routing
